import React from 'react';
import './home.css'
import VideoOnly from '../Components/VideoOnly.js'
import BrandsSlick from '../Components/BrandsSlick.js'
import Services from '../Components/Services.js'
import Team from '../Components/Team.js'
import Brands from '../Components/Brands.js'
import Works from '../Components/Works.js'
import Contact from '../Components/Contact.js'
import Ecommerce from '../Components/Ecommerce.js'
import IndexInNumbers from '../Components/IndexInNumbers.js'
import Footer from '../Components/Footer.js'

function Home() {
  return (
    <div className='home'>
          <VideoOnly/>
          <BrandsSlick/>
          <Works/>
          <Services/>
          <Brands/>
          <Team/>
          <Ecommerce/>
          <IndexInNumbers/>
          <Contact/>
          <Footer />
    </div>
  );
}
export default Home;